import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';

const RESULTS_PAGE = '/BF/flights/results/';
export const TRIP_SUMMARY_PAGE = '/BF/flights/summary/';
export const FILTERS_PAGE = '/BF/flights/flights-filter/';
export const NO_FILTERED_ITINERARIES_PAGE =
  '/BF/flights/error/results_error_filtering_no_results_found/';
export const NO_SEARCH_ITINERARIES_PAGE =
  '/BF/flights/error/results_error_no_itineraries_results/';
export const VALIDATION_SEARCH_ERROR_PAGE =
  '/BF/flights/error/results_error_validation_error/';
export const SEM_RESULTS_PAGE = '/BF/flights/results/';

export const RESULTS_CATEGORY = 'flights_results';
export const TRIP_SUMMARY_CATEGORY = 'flights_summary';
export const SEM_RESULTS_CATEGORY = 'flights_results_inspirational';

const pagesMap = {
  filters: FILTERS_PAGE,
  trip_summary: TRIP_SUMMARY_PAGE,
};

const pageMapper = (page) => pagesMap[page] || RESULTS_PAGE;

export const ResultsPageTrackingProvider = createTrackingPageProvider({
  category: RESULTS_CATEGORY,
  pageViewName: RESULTS_PAGE,
  pageMapper,
});

export const TripSummaryPageTrackingProvider = createTrackingPageProvider({
  category: TRIP_SUMMARY_CATEGORY,
  pageViewName: TRIP_SUMMARY_PAGE,
  pageMapper,
});

export const SemResultsPageTrackingProvider = createTrackingPageProvider({
  category: SEM_RESULTS_CATEGORY,
  pageViewName: SEM_RESULTS_PAGE,
  pageMapper,
});
